import { LIVE_DEFAULTS } from './constants';

export interface EventData {
    venue_capacity: number | null;
    ticket_price_low: number | null;
    ticket_price_high: number | null;
}

export interface LiveRevenueEstimate {
    eventsPerYear: number;
    avgVenueCapacity: number;
    avgTicketPrice: number;
    annualGross: number;
    producerShare: number;
}

export function estimateLiveRevenue(
    events: EventData[],
    producerSplitPercent: number
): LiveRevenueEstimate {
    if (!events.length) {
        return {
            eventsPerYear: 0,
            avgVenueCapacity: 0,
            avgTicketPrice: 0,
            annualGross: 0,
            producerShare: 0,
        };
    }

    const capacities = events
        .map((e) => e.venue_capacity)
        .filter((c): c is number => c != null && c > 0);
    const avgVenueCapacity = capacities.length
        ? Math.round(capacities.reduce((a, b) => a + b, 0) / capacities.length)
        : 500; // default if no capacity data

    const prices = events
        .map((e) => {
            const low = e.ticket_price_low ?? 0;
            const high = e.ticket_price_high ?? 0;
            if (low > 0 && high > 0) return (low + high) / 2;
            if (low > 0) return low;
            if (high > 0) return high;
            return 0;
        })
        .filter((p) => p > 0);
    const avgTicketPrice = prices.length
        ? Math.round(prices.reduce((a, b) => a + b, 0) / prices.length)
        : 30; // default

    const eventsPerYear = events.length;

    const annualGross =
        eventsPerYear *
        avgVenueCapacity *
        avgTicketPrice *
        LIVE_DEFAULTS.fillRate;

    const producerShare = annualGross * LIVE_DEFAULTS.headlinerShare * (producerSplitPercent / 100);

    return {
        eventsPerYear,
        avgVenueCapacity,
        avgTicketPrice,
        annualGross: Math.round(annualGross),
        producerShare: Math.round(producerShare),
    };
}
